import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useIsMobile } from './hooks/isMobile';
import ExamHeader from './components/ExamHeader/ExamHeader';
import ExamNavigation from './components/ExamNavigation/ExamNavigation';
import ExamStatusBar from './components/ExamStatusBar/ExamStatusBar';
import QuestionDisplay from './components/QuestionDisplay/QuestionDisplay';
import QuestionControls from './components/QuestionControls/QuestionControls';
import QuestionPagination from './components/QuestionPagination/QuestionPagination';
import './previewTest.scss';
import { getQuestion, getQuestionById } from '../../store/questionSlice';
import { useDispatch, useSelector } from 'react-redux';
const examData = {
  title: "Central Bank Credit officer - (Mastery Moment): Mini Live Test",
  sections: ["English Language", "Quantitative Aptitude", "Reasoning Ability", "General Awareness"],
  timeRemaining: "00 : 40 : 17",
  questions: [
    "____ is elected as the first female President of the International Olympic Committee (IOC)."
  ]
};

const sampleQuestions =
{
  number: 1,
  text: "____ is elected as the first female President of the International Olympic Committee (IOC).",
  options: [
    "A) Mary Smith",
    "B) Sarah Johnson",
    "C) Emma Wilson",
    "D) Olivia Brown"
  ]
};
const PreviewTest = () => {
  const location = useLocation();
  const isMobile = useIsMobile();
  const dispatch = useDispatch();
  const storeVar = useSelector(state => state.question)
  const [activeSection, setActiveSection] = useState("General Awareness");
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [answeredQuestions, setAnsweredQuestions] = useState([]);
  const [markedQuestions, setMarkedQuestions] = useState([]);
  const [visitedQuestions, setVisitedQuestions] = useState([1]);
  const [timeLeft, setTimeLeft] = useState("00 : 30");
  const [showSidebar, setShowSidebar] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id");
    dispatch(getQuestionById(id))
  }, [location.search]);


  const handleSectionChange = (section) => {
    setActiveSection(section);
    setCurrentQuestion(1);
    toast.success(`Switched to ${section} section`);
  };

  const handleQuestionChange = (questionNumber) => {
    setCurrentQuestion(questionNumber);
    if (!visitedQuestions.includes(questionNumber)) {
      setVisitedQuestions([...visitedQuestions, questionNumber]);
    }
    if (isMobile) setShowSidebar(false);
  };

  const handleAnswerSelect = (answer) => {
    setSelectedAnswers({
      ...selectedAnswers,
      [currentQuestion]: answer
    });
  };

  const handleMarkForReview = () => {
    if (!markedQuestions.includes(currentQuestion)) {
      setMarkedQuestions([...markedQuestions, currentQuestion]);
    }
    if (selectedAnswers[currentQuestion] && !answeredQuestions.includes(currentQuestion)) {
      setAnsweredQuestions([...answeredQuestions, currentQuestion]);
    }
    if (currentQuestion < 10) handleQuestionChange(currentQuestion + 1);
    toast.info("Question marked for review");
  };

  const handleClearResponse = () => {
    const newSelectedAnswers = { ...selectedAnswers };
    delete newSelectedAnswers[currentQuestion];
    setSelectedAnswers(newSelectedAnswers);
    setAnsweredQuestions(answeredQuestions.filter(q => q !== currentQuestion));
    toast.info("Response cleared");
  };

  const handleSaveAndNext = () => {
    if (selectedAnswers[currentQuestion] && !answeredQuestions.includes(currentQuestion)) {
      setAnsweredQuestions([...answeredQuestions, currentQuestion]);
      toast.success("Answer saved");
    } else if (!selectedAnswers[currentQuestion]) {
      toast.warning("No answer selected");
    }
    if (currentQuestion < 10) handleQuestionChange(currentQuestion + 1);
  };

  const handleSectionSubmit = () => toast.success(`${activeSection} section submitted successfully`);
  const handleSubmitTest = () => toast.success("Test submitted successfully");
  const handleReport = () => {
    // toast.info("Report submitted")
  };
  const toggleSidebar = () => setShowSidebar(!showSidebar);
  return (
    <div className="exam-interface">
      {/* <ExamHeader examTitle={storeVar.questionDetails.lessonId} timeRemaining={timeLeft} /> */}
      {/* <ExamNavigation sections={examData.sections} activeSection={activeSection} onSectionChange={handleSectionChange} /> */}
      <ExamStatusBar username="O2" answeredCount={answeredQuestions.length} markedCount={markedQuestions.length} notVisitedCount={10 - visitedQuestions.length} notAnsweredCount={visitedQuestions.length - answeredQuestions.length} onReport={handleReport} />

      {isMobile && (
        <div className="mobile-header">
          <div>Question {currentQuestion}</div>
          <button onClick={toggleSidebar}>
            {showSidebar ? "Hide Panel" : "Show Panel"}
          </button>
        </div>
      )}

      <div className="main-content">
        <div className={`question-area ${isMobile && showSidebar ? 'hidden' : ''}`}>
          <QuestionDisplay questionNumber={currentQuestion} question={storeVar.questionDetails} selectedAnswer={selectedAnswers[currentQuestion] || null} onAnswerSelect={handleAnswerSelect} />
          <QuestionControls onMarkForReview={handleMarkForReview} onClearResponse={handleClearResponse} onSaveAndNext={handleSaveAndNext} />
        </div>

        <div className={`sidebar ${isMobile && !showSidebar ? 'hidden' : ''}`}>
          <QuestionPagination totalQuestions={10} currentQuestion={currentQuestion} answeredQuestions={answeredQuestions} markedQuestions={markedQuestions} visitedQuestions={visitedQuestions} onQuestionChange={handleQuestionChange} onSectionSubmit={handleSectionSubmit} activeSection={activeSection} questionsList={sampleQuestions} />
        </div>
      </div>

    </div>
  )
}

export default PreviewTest